import React, {Component} from 'react';
import HeaderComponent
    from "../../../../Components/HeaderComponent/HeaderComponent";
import {Box, Typography} from "@material-ui/core";
import CampaignService from "../../../../Services/CampaignService";
import MessageUtil from "../../../../Utils/MessageUtil";
import ContentListMeta from "./ContentListMeta";
import PaginationComponent
    from "../../../../Components/PaginationComponent/PaginationComponent";

class ListCampaignMetaScreen extends Component {
    static ROUTE = '/list-campaigns-meta'

    constructor(props) {
        super(props);

        this.state = {
            metaData: null,
            inLoad: false,
            messagens: null,
        };

        this.campaignService = new CampaignService();
    }

    componentDidMount() {
        this.load();
    }

    async load(page = 1) {
        try {
            this.setState({
                inLoad: true,
            });

            const response = await this.campaignService.getClientGoal(page);

            this.setState({
                inLoad: false,
                metaData: response.data,
            });
        } catch (e) {
            this.setState({
                inLoad: false,
                messagens: MessageUtil.make({
                    title: 'Error',
                    body: e,
                }),
            });
        }
    }

    render() {
        return (
            <div>
                <HeaderComponent title={'Campanhas Mesta Salvas'}
                                 menu={true}
                                 messagens={this.state?.messagens}
                                 inLoad={this.state.inLoad}/>
                <Typography align={'center'}
                            variant={'h6'}
                            color={'primary'}>
                    Campanhas por Meta
                </Typography>
                <br/>
                <Box display={'flex'}
                     justifyContent={'center'}
                     alignItems={'center'}>
                    <Box width={'80%'}>
                        <ContentListMeta metaData={this.state.metaData}/>
                        <PaginationComponent
                            total={parseInt(this.state?.metaData?.meta.total)}
                            perPage={parseInt(this.state?.metaData?.meta.per_page)}
                            currentPage={parseInt(this.state?.metaData?.meta.current_page)}
                            itensVisible={2}
                            onChangePage={(page) => {
                                this.load(page);
                            }}/>
                    </Box>
                </Box>
            </div>
        );
    }
}

export default ListCampaignMetaScreen;